<template>
<!-- 图片上传 -->
  <div class="upload-image">
    <div
    class="file-item"
    v-for="file in fileList"
    :class="{'success': file.frontUsedStatus==='1','error': file.frontUsedStatus==='2'}"
    :key="file.fileUniqueCode">
      <!-- 上传中，显示loading -->
      <a-icon class="file-item-loading" v-if="file.frontUsedStatus==='0'" type="loading"></a-icon>
      <!-- 成功，显示图片 -->
      <img class="file-item-img" v-if="file.frontUsedStatus==='1'" :src="file.fileUrl" alt="图片">
      <!-- 失败，显示上传失败 -->
      <span class="file-item-name" v-if="file.frontUsedStatus==='2'">上传失败</span>
      <!-- 删除icon -->
      <a-icon class="file-item-del" v-if="file.frontUsedStatus!=='0'" type="close" @click="del($event, file)"></a-icon>
    </div>
    <div class="file-item upload-btn" v-if="showAddBtn" @click="clickAdd">
      <a-icon type="plus"/>
      <input type="file" ref="fileInput" :multiple="multi" id="file-input" @change="fileSel">
    </div>
  </div>
</template>
<script>
  import UUID from 'uuid-js'
  import { upload } from '@/utils/request'

  export default {
    name: 'UploadImage',
    /**
     * 基于文件上传的异步，以及上传校验等问题，此组件的编辑状态下，需要父组件手动调用validate()来获取当前附件的上传状态；
     *  validate函数会返回校验结果Boolean；同时，在校验通过的情况下，更新files的值
     * */
    props: {
      value: { type: Array, default: () => [] }, // 已有文件，支持v-model
      multi: { type: Boolean, default: false }, // 是否支持多项
      maxNum: { type: Number }, // 文件个数上限，默认无上限
      maxSize: { type: Number, default: 100 }, // 最大文件size，默认 100M
    },
    data() {
      return {
        fileList: [],
        reqList: {},
      }
    },
    watch: {
      value: {
        handler(n) {
          this.fileList = Array.from(n)
        },
        immediate: true
      }
    },
    computed: {
      // 是否显示上传按钮
      showAddBtn() {
        if (!this.maxNum || (this.maxNum && this.maxNum > this.fileList.length)) {
          return true
        }
        return false
      }
    },
    methods: {
      // 校验函数，提供給父组件用 返回 Boolean
      validate() {
        let flag = true
        for (const item of this.fileList) {
          if (item.frontUsedStatus === '0') {
            flag = false
            this.$message.warning('文件正在上传中…')
            break
          } else if (item.frontUsedStatus === '2') {
            flag = false
            this.$message.warning('文件上传失败')
            break
          }
        }
        // 如果校验通过，则更新数据
        if (flag) {
          this.$emit('input', [...this.fileList])
        }
        return flag
      },
      // 点击添加
      clickAdd() {
        this.$refs.fileInput.click()
      },
      // 选择文件
      fileSel(e) {
        const files = Array.from(e.target.files)
        // 判断文件大小
        if (files.some(file => file.size > this.maxSize * 1024 * 1024)) {
          this.$message.warning(`单个文件大小不得超过${this.maxSize}M`)
          return
        }
        // 判断文件数量
        if (this.maxNum && (files.length + this.fileList.length) > this.maxNum) {
          this.$message.warning(`图片数量最多${this.maxNum}张`)
          return
        }
        // 判断文件类型
        if (files.some(file => file.type.indexOf('image') < 0)) {
          this.$message.warning(`只支持上传图片`)
          return
        }
        // 创建新的文件对象
        const newItems = files.map(this.createItem)
        this.fileList = [...this.fileList, ...newItems]
        this.$refs.fileInput.value = ''
      },
      // 上传状态变更
      itemChange(item) {
        const value = [...this.fileList]
        const index = value.findIndex(v => v.fileUniqueCode === item.fileUniqueCode)
        if (index > -1) {
          value.splice(index, 1, { ...value[index], ...item })
          this.fileList = value
        }
      },
      // 创建新的附件对象
      createItem(file) {
        const fileUniqueCode = UUID.create().toString()
        file.fileUniqueCode = fileUniqueCode
        const item = {
          fileUniqueCode,
          fileName: file.name,
          fileUrl: '',
          fileSize: file.size,
          fileType: file.type,
          frontUsedStatus: '0',
          id: ''
        }
        upload(file, {
          onSuccess: res => {
            this.itemChange({
              fileUniqueCode,
              frontUsedStatus: '1',
              fileUrl: res
            })
          },
          onError: (err)=> {
              this.itemChange({
              fileUniqueCode,
              frontUsedStatus: '2'
            })
            this.$message.error(err.msg)
          }
        })
        // 上传进度
        return item
      },
      // 删除
      del(e, item) {
        e.stopPropagation()
        this.fileList = this.fileList.filter(v => v.fileUniqueCode !== item.fileUniqueCode)
        this.$emit('input', [...this.fileList])
        // 中止上传
        if (this.reqList[item.fileUniqueCode]) {
          this.reqList[item.fileUniqueCode].cancel()
        }
      },
    }
  }
</script>

<style lang="less" scoped>
.upload-image{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .upload-btn{
    background-color: #F0F1F3;
    border: 1px dashed #CDCED5;
    cursor: pointer;
    &:hover {
      border-color: #a7a8ad;
    }
    .anticon{
      font-size: 14px;
      color: rgba(4, 12, 44, 0.65);
    }
  }
  #file-input{
    display: none;
  }
  .file-item{
    flex: 0 0 100px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 75px;
    margin-right: 8px;
    margin-bottom: 8px;
    color: rgba(4,12,44,0.65);

    &.error {
      background-color: #F0F1F3;
      border: 1px solid #e93737;
    }
    .file-item-loading {
      font-size: 18px;
    }
    .file-item-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .file-item-name{
      flex: 1;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .file-item-del{
      position: absolute;
      top: 5px;
      right: 5px;
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      background: rgba(255, 255, 255, .8);
      color: #555;
      &:hover {
        background-color: #fff;
      }
    }
  }
}
</style>
